import "../../styles/styles.css";
import { useState } from "react";
import { Container, Card, Nav } from "react-bootstrap";
import UserLayout from "../../components/custom/layouts/UserLayout";
import GstInvoiceWiseReport from "../../components/report/GstSalesInvoiceWiseReport";
import GstSalesInvoiceWise from "../../components/report/GstSalesInvoiceWiseReport";
import GstSalesHsnReport from "../../components/report/GstSalesHsnReport";
import GstSalesReturnInvoiceWise from "../../components/report/GstSalesReturnInvoiceWiseReport";
import GstSalesReturnHsnReport from "../../components/report/GstSalesReturnHsnReport";

const GstSalesReport = () => {
    const [activeTab, setActiveTab] = useState("sales-invoice");

    return (
      <UserLayout>
        <h3 className="mb-2 font-bold">GST Sales Report</h3>

        <Container fluid className="p-4 shadow-lg bg-white rounded">
          <Nav
            variant="pills"
            className="custom-tabs mb-2 justify-content-start"
            activeKey={activeTab}
            onSelect={(selectedKey) =>
              setActiveTab(selectedKey || "sales-invoice")
            }
          >
            <Nav.Item>
              <Nav.Link eventKey="sales-invoice" className="custom-tab">
                GST Sales Invoice Wise
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="sales-hsn" className="custom-tab">
                GST Sales HSN Wise
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="sales-return-invoice" className="custom-tab">
                GST Sales Return Invoice Wise
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="sales-return-hsn" className="custom-tab">
                GST Sales Return HSN Wise
              </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Nav.Link eventKey="customer" className="custom-tab">
                GST Customer Bill Wise
              </Nav.Link>
            </Nav.Item> */}
          </Nav>

          {/* Tab Content */}
          <Card className="tab-content-card">
            {activeTab === "sales-invoice" && (
              <GstSalesInvoiceWise />
            )}
            {activeTab === "sales-hsn" && (
             <GstSalesHsnReport />
            )}
            {activeTab === "sales-return-invoice" && (
            <GstSalesReturnInvoiceWise />
            )}
            {activeTab === "sales-return-hsn" && (
            <GstSalesReturnHsnReport />
            )}
            {/* {activeTab === "customer" && (
              <TabContent title="GST Customer Bill Wise" />
            )} */}
          </Card>
        </Container>
      </UserLayout>
    );
};

// Tab Content Component
interface TabContentProps {
    title: string;
}

// Tab Content Component with explicit type
const TabContent: React.FC<TabContentProps> = ({ title }) => (
    <>
        {title === "GST Sales Invoice Wise" && <div />}
        {title === "GST Sales HSN Wise" && <div />}
        {title === " GST Sales Return Invoice Wise" && <div />}
        {title === "GST Sales Return HSN Wise" && <div />}
    </>
);

export default GstSalesReport;
